module.exports = __webpack_public_path__ + "h5/img/tip.86fd2059.png";